// Owner portal dedicated host (owner.hostea.io) — sibling of app.hostea.io.
// Same build serves both domains; DomainGuard splits traffic by hostname.

export const OWNER_HOST = 'owner.hostea.io';

// Set REACT_APP_OWNER_PORTAL_URL (e.g. https://owner.hostea.io) to activate the
// app→owner redirect and the admin "copy portal URL" pointing to the new domain.
// Absent = feature dormant (rollout step 2).
export const OWNER_PORTAL_URL = process.env.REACT_APP_OWNER_PORTAL_URL || null;

export const isOwnerHost = () =>
  window.location.hostname === OWNER_HOST ||
  process.env.REACT_APP_FORCE_OWNER_HOST === '1';

// Matches /:slug/owner and /:slug/owner/*, plus the slugless reset route /owner/*
// (the LONG legacy form — used by the app-host redirect for old links/emails)
export const isOwnerPortalPath = (pathname) =>
  /^\/[^/]+\/owner(\/|$)/.test(pathname) || pathname.startsWith('/owner/');

/**
 * Canonical owner-portal path builder — SHORT on the owner host
 * (owner.hostea.io/:slug/home), legacy long form elsewhere (/:slug/owner/home).
 * Every owner-portal navigation/link must go through this helper.
 */
export const ownerPath = (slug, sub = '') => {
  const base = isOwnerHost() ? `/${slug}` : `/${slug}/owner`;
  if (!sub) return isOwnerHost() ? `/${slug}` : `/${slug}/owner/login`;
  return `${base}/${sub}`;
};
